/**
 * Searchable multi-select for provider profile pick-lists
 */

import React from "react";
import { Autocomplete, Chip, TextField } from "@mui/material";

const ProviderOptionMultiSelect = ({
  label,
  options = [],
  value = [],
  onChange,
  helperText,
  placeholder = "Type to search…",
  disabled = false,
}) => {
  const catalogMap = new Map(options.map((option) => [option.value, option]));

  const selectedOptions = (value || []).map((entry) => {
    if (entry && typeof entry === "object" && entry.value) {
      return catalogMap.get(entry.value) || entry;
    }
    const key = String(entry);
    return catalogMap.get(key) || { value: key, label: key };
  });

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={options}
      value={selectedOptions}
      disabled={disabled}
      onChange={(_, newOptions) => {
        onChange(newOptions.map((option) => option.value));
      }}
      getOptionLabel={(option) => option.label || option.value || ""}
      isOptionEqualToValue={(a, b) => a.value === b.value}
      filterSelectedOptions
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={`${option.value}-${index}`}
            label={option.label || option.value}
            size="small"
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={selectedOptions.length ? "" : placeholder}
          helperText={helperText}
        />
      )}
    />
  );
};

export default ProviderOptionMultiSelect;
